<article
  class="listing-card rounded-lg shadow cursor-pointer group border hover:!border-OUT-Blue transition-all duration-300 overflow-hidden"
  [routerLink]="getRouterLink()"
>
  <!-- Image -->
  <div
    class="h-[230px] sm:h-[240px] md:h-[250px] lg:h-[270px] 2xl:h-[280px] relative"
  >
    <!-- Pills -->
    <div
      class="flex justify-between w-[93%] absolute left-2.5 me-5 right-3 top-2.5 z-10"
    >
      <div class="flex gap-1.5 items-center">
        <out-listing-type [type]="listing?.type"></out-listing-type>
        <span
          class="bg-black rounded-full text-white text-xs px-3 py-1"
          >{{
            listing?.dealer === 'Individual Seller'
              ? 'Private Seller'
              : 'Dealer'
          }}</span
        >
      </div>
    </div>

    <button
      *ngIf="listing?.vehicle?.tax?.relief === true && !allowEdit"
      class="bg-white/90 font-semibold w-fit px-4 py-1 rounded-xl border flex items-center justify-center gap-1.5 mx-auto cursor-pointer absolute z-1 bottom-2 left-0 right-0"
    >
      {{ (listing?.price?.value ?? 0) - 4000 | currency }}
      <span class="flex items-center justify-center gap-2"
        >after tax relief
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
        >
          <g
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4m0-4h.01" />
          </g></svg
      ></span>
    </button>

    <button
      *ngIf="allowEdit  && listing?.status === 'New'"
      class="font-semibold w-fit px-4 py-1 rounded-xl flex items-center justify-center gap-1.5 mx-auto cursor-pointer absolute z-1 bottom-2 left-0 right-0 bg-white"
      [ngClass]="listing?.isPaid? 'text-green-600': 'text-red-600'"
    >
      <span>{{ listing?.isPaid ? 'Paid' : 'Unpaid' }}</span>
    </button>

    <button
      *ngIf="listing?.vehicle?.tax?.reliefApplied === true && !allowEdit"
      class="bg-white/90 font-semibold w-fit px-4 py-1 rounded-xl border flex items-center justify-center gap-1.5 mx-auto cursor-pointer absolute z-1 bottom-2 left-0 right-0"
    >
      Used EV Tax Credit Eligibility
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
      >
        <g
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 16v-4m0-4h.01" />
        </g>
      </svg>
    </button>

    <img
      [ngSrc]="getImageUrl()"
      (error)="onImageError($event)"
      class="h-full w-full object-cover"
      [alt]="listing?.vehicle?.model || 'Tesla vehicle'"
      fill
      priority
    />
  </div>

  <!-- Info -->
  <div class="w-full px-4 py-2.5 description">
    <div class="flex items-center gap-1 my-1.5">
      <div class="text-blue-600">
        <svg
          class="size-4"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
          />
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M17.8 13.938h-.011a7 7 0 1 0-11.464.144h-.016l.14.171c.1.127.2.251.3.371L12 21l5.13-6.248c.194-.209.374-.429.54-.659l.13-.155Z"
          />
        </svg>
      </div>
      <span
        class="text-ellipsis md:text-md font-semibold opacity-65 overflow-hidden whitespace-nowrap"
      >
        {{ listing?.location?.city }},
        {{ listing?.location?.state }}
      </span>
    </div>

    <h4 class="md:h-12 leading-[1.2] text-lg font-semibold">
      {{ listing?.vehicle?.year }} {{ listing?.vehicle?.model }}
      {{ listing?.vehicle?.trim }}
      {{ listing?.vehicle?.specification?.colour }}
    </h4>

    <div
      *ngIf="showDescription"
      class="listing-card__excerpt-desktop h-[4.8rem] text-[#303336] fade overflow-hidden relative"
    >
      <p
        class="break-words hyphens-auto"
        [innerHTML]="sanitizedHtmlContent"
      ></p>
    </div>

    <div class="grid grid-cols-2 w-full my-2.5 opacity-80">
      <span class="flex flex-shrink-0 justify-start gap-1.5 items-center"
        ><svg
          xmlns="http://www.w3.org/2000/svg"
          class="size-4"
          viewBox="0 0 512 512"
        >
          <path
            fill="currentColor"
            d="m326.1 231.9l-47.5 75.5a31 31 0 0 1-7 7a30.11 30.11 0 0 1-35-49l75.5-47.5a10.23 10.23 0 0 1 11.7 0a10.06 10.06 0 0 1 2.3 14"
          />
          <path
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="32"
            d="M256 64C132.3 64 32 164.2 32 287.9a223.18 223.18 0 0 0 56.3 148.5c1.1 1.2 2.1 2.4 3.2 3.5a25.19 25.19 0 0 0 37.1-.1a173.13 173.13 0 0 1 254.8 0a25.19 25.19 0 0 0 37.1.1l3.2-3.5A223.18 223.18 0 0 0 480 287.9C480 164.2 379.7 64 256 64"
          />
          <path
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="32"
            d="M256 128v32m160 128h-32m-256 0H96m69.49-90.51l-22.63-22.63m203.65 22.63l22.63-22.63"
          /></svg
        ><span class="text-sm 2xl:text-base"
          >{{ listing?.vehicle?.mileage | number : '1.0-0' }} mi</span
        ></span
      >
      <!-- <span
        class="flex flex-shrink-0 justify-center gap-2 items-center 2xl:px-1.5"
      >
        <svg
          class="size-4"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M4 9.05H3v2h1v-2Zm16 2h1v-2h-1v2ZM10 14a1 1 0 1 0 0 2v-2Zm4 2a1 1 0 1 0 0-2v2Zm-3 1a1 1 0 1 0 2 0h-2Zm2-4a1 1 0 1 0-2 0h2Zm-2-5.95a1 1 0 1 0 2 0h-2Zm2-3a1 1 0 1 0-2 0h2Zm-7 3a1 1 0 0 0 2 0H6Zm2-3a1 1 0 1 0-2 0h2Zm8 3a1 1 0 1 0 2 0h-2Zm2-3a1 1 0 1 0-2 0h2Zm-13 3h14v-2H5v2Zm14 0v12h2v-12h-2Zm0 12H5v2h14v-2Zm-14 0v-12H3v12h2Zm0 0H3a2 2 0 0 0 2 2v-2Zm14 0v2a2 2 0 0 0 2-2h-2Zm0-12h2a2 2 0 0 0-2-2v2Zm-14-2a2 2 0 0 0-2 2h2v-2Zm-1 6h16v-2H4v2ZM10 16h4v-2h-4v2Zm3 1v-4h-2v4h2Zm0-9.95v-3h-2v3h2Zm-5 0v-3H6v3h2Zm10 0v-3h-2v3h2Z"
          />
        </svg>
        <span class="text-sm 2xl:text-base">{{ listing?.vehicle?.year }}</span>
      </span> -->
      <span class="flex flex-shrink-0 justify-end gap-2 items-center"
        ><span
          class="rounded-2xl text-center text-sm w-fit py-1 font-medium"
          [ngClass]="
            colorGradeCarCondition(listing?.vehicle?.condition || null)
          "
        >
          <span class="text-sm 2xl:text-base">{{
            listing?.vehicle?.condition || 'Unknown' | capitalizeWithSpaces
          }}</span>
        </span>
      </span>
    </div>

    <div class="flex border-t justify-between gap-4 items-center pt-2">
      <p class="flex flex-col text-sm">
        <span class="text-xs">Listing Date:</span>
        <strong class="text-[#000]/80 text-lg font-semibold">{{
          listing?.created | date : 'MMM d, yyyy'
        }}</strong>
      </p>
      <p class="flex flex-col justify-end text-sm">
        <span class="text-end text-xs">Asking Price:</span>
        <strong class="text-[#000]/80 text-lg font-semibold">{{
          listing?.price?.value | currency : listing?.price?.currency : 'symbol'
        }}</strong>
      </p>
    </div>
  </div>
</article>
